// @flow
import { PAGES_SHOPIFY_INTEGRATION } from 'src/constants/theme-settings';
import { TURBO_FEATURE } from './installation-v2';
import { getAssetURL } from 'src/helpers';
import { ADMIN_APP_ASSET_PATHS } from './assets';
export const LIMIT_CUSTOM_TEMPLATE_INSTANCE = 25;

export const TEMPLATE_FEATURE = {
  BOOST: 'boost',
  COLLECTION: 'collection',
  SEARCH: 'search',
  ISW: 'instant-search-widget',
  RECOMMENDATION: 'recommendation'
};

export const INTEGRATION_FEATURE = {
  COLLECTION: 'collectionFilters',
  SEARCH: 'searchPage',
  ISW: 'instantSearchWidget',
  RECOMMENDATION: 'recommendation'
};

export const WIDGET_FEATURES = [
  {
    pathId: TEMPLATE_FEATURE.COLLECTION,
    featureId: INTEGRATION_FEATURE.COLLECTION,
    name: 'Collection page with filters',
    content: 'AdminHTML.ShopifyIntegration.Onboarding.step03_Feature01_Content',
    img: getAssetURL(ADMIN_APP_ASSET_PATHS?.shopifyIntegration.collectionFeature)
  },
  {
    pathId: TEMPLATE_FEATURE.SEARCH,
    featureId: INTEGRATION_FEATURE.SEARCH,
    name: 'Search page with filters',
    content: 'AdminHTML.ShopifyIntegration.Onboarding.step03_Feature02_Content',
    img: getAssetURL(ADMIN_APP_ASSET_PATHS?.shopifyIntegration.searchWithFilterFeature)
  },
  {
    pathId: TEMPLATE_FEATURE.ISW,
    featureId: INTEGRATION_FEATURE.ISW,
    name: 'Instant search widget',
    content: 'AdminHTML.ShopifyIntegration.Onboarding.step03_Feature03_Content',
    img: getAssetURL(ADMIN_APP_ASSET_PATHS?.shopifyIntegration.iswFeature)
  }
  // {
  //   pathId: TEMPLATE_FEATURE.RECOMMENDATION,
  //   featureId: INTEGRATION_FEATURE.RECOMMENDATION,
  //   name: 'Recommendation widgets'
  // }
];

export const SSR_APP_BLOCK = {
  FILTER_PRODUCT_LIST_SSR: 'filter-product-list-ssr',
  RECOMMENDATION: 'recommendation-ssr'
};

// For local storage
export const KEY_EDITOR_STATE = 'editor-state';

export const TEMPLATE_VALUE = {
  COLLECTION: 'collectionFilters',
  SEARCH: 'searchPage'
};
export const AVAILABLE_TEMPLATE = [TEMPLATE_VALUE.COLLECTION, TEMPLATE_VALUE.SEARCH];
export const MAPPING_AVAILABLE_TEMPLATE = {
  [PAGES_SHOPIFY_INTEGRATION.COLLECTION]: TEMPLATE_VALUE.COLLECTION,
  [PAGES_SHOPIFY_INTEGRATION.SEARCH]: TEMPLATE_VALUE.SEARCH
};

export const ERROR_CODE = {
  REACH_LIMIT: 'REACH_LIMIT',
  ALREADY_ADDED: 'ALREADY_ADDED'
};

const isStaging = process.env.REACT_APP_ENV === 'staging';
export const VISIBLE_TEMPLATE_SETTING_ELEMENT = {
  default: {
    PRODUCT_ITEM: isStaging ? '1.5.6' : '1.4.0',
    PRODUCT_ITEM_ADDITIONAL_RATING: isStaging ? '1.5.6' : '1.5.0',
    PRODUCT_ITEM_SWATCH_QUICKVIEW_CART_PRICE_CTA: isStaging ? '1.6.19' : '1.6.0',
    PRODUCT_ITEM_BTN_LAYOUT_3: isStaging ? '1.7.2' : '1.8.0',
    PRODUCT_ITEM_BTN_LAYOUT_BULK: isStaging ? '3.4.22' : '2.12.0',
    PRODUCT_ITEM_BTN_LAYOUT_4: isStaging ? '3.4.22' : '2.12.0',
    PRODUCT_ITEM_BTN_LAYOUT_6: isStaging ? '3.11.16' : '2.24.0',
    PRODUCT_ITEM_BTN_LAYOUT_7: isStaging ? '3.11.16' : '2.24.0',
    PRODUCT_ITEM_BTN_LAYOUT_5: isStaging ? '3.15.13' : '2.26.0',
    PRODUCT_ITEM_BTN_LAYOUT_8: isStaging ? '3.15.26' : '2.27.0',
    CART_VISIBILITY_SETTINGS: isStaging ? '3.6.24' : '2.14.0',
    PRODUCT_VENDOR: isStaging ? '3.6.30' : '2.14.0',
    PRODUCT_ITEM_INVENTORY_STATUS: isStaging ? '3.11.10' : '2.21.0',
    PRODUCT_LIST_BREADCRUMBS: isStaging ? '3.11.10' : '2.21.0',
    COLLECTION_HEADER_PARALLAX: isStaging ? '3.11.2' : '2.22.3',
    PRODUCT_SWATCH_BY: isStaging ? '6.0.7' : '2.34.0',
    SHOW_TEXT_ON_HOVERING: isStaging ? '3.11.2' : '2.22.3',
  },
  dawn: {
    PRODUCT_ITEM: isStaging ? '1.5.3' : '1.4.0',
    PRODUCT_ITEM_ADDITIONAL_RATING: isStaging ? '1.5.3' : '1.5.0',
    PRODUCT_ITEM_SWATCH_QUICKVIEW_CART_PRICE_CTA: isStaging ? '1.6.14' : '1.6.0',
    CART_VISIBILITY_SETTINGS: isStaging ? '3.6.24' : '2.14.0',
    PRODUCT_VENDOR: isStaging ? '3.6.30' : '2.14.0',
    PRODUCT_ITEM_INVENTORY_STATUS: isStaging ? '3.11.10' : '2.21.0',
    PRODUCT_LIST_BREADCRUMBS: isStaging ? '3.11.10' : '2.21.0',
    COLLECTION_HEADER_PARALLAX: isStaging ? '3.11.2' : '2.22.3',
    PRODUCT_SWATCH_BY: isStaging ? '6.1.3' : '2.34.0'
  },
  impulse: {
    PRODUCT_ITEM: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_ITEM_ADDITIONAL_RATING: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_ITEM_SWATCH_QUICKVIEW_CART_PRICE_CTA: isStaging ? '1.0.0' : '1.0.0',
    CART_VISIBILITY_SETTINGS: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_VENDOR: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_ITEM_INVENTORY_STATUS: isStaging ? '1.14.10' : '1.4.0',
    PRODUCT_LIST_BREADCRUMBS: isStaging ? '1.14.10' : '1.4.0',
    COLLECTION_HEADER_PARALLAX: isStaging ? '1.14.0' : '1.5.3',
    PRODUCT_SWATCH_BY: isStaging ? '1.3.3' : '1.17.0'
  },
  warehouse: {
    PRODUCT_ITEM: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_ITEM_ADDITIONAL_RATING: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_ITEM_SWATCH_QUICKVIEW_CART_PRICE_CTA: isStaging ? '1.0.0' : '1.0.0',
    CART_VISIBILITY_SETTINGS: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_VENDOR: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_ITEM_INVENTORY_STATUS: isStaging ? '1.14.10' : '1.4.0',
    PRODUCT_LIST_BREADCRUMBS: isStaging ? '1.14.10' : '1.4.0',
    COLLECTION_HEADER_PARALLAX: isStaging ? '1.14.0' : '1.5.3',
    PRODUCT_SWATCH_BY: isStaging ? '6.1.3' : '1.57.0'
  },
  symmetry: {
    PRODUCT_ITEM: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_ITEM_ADDITIONAL_RATING: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_ITEM_SWATCH_QUICKVIEW_CART_PRICE_CTA: isStaging ? '1.0.0' : '1.0.0',
    CART_VISIBILITY_SETTINGS: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_VENDOR: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_ITEM_INVENTORY_STATUS: isStaging ? '1.1.15' : '1.3.0',
    PRODUCT_LIST_BREADCRUMBS: isStaging ? '1.1.15' : '1.3.0',
    COLLECTION_HEADER_PARALLAX: isStaging ? '1.14.0' : '1.4.3',
    PRODUCT_SWATCH_BY: isStaging ? '4.1.3' : '1.56.0'
  },
  prestige: {
    PRODUCT_ITEM: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_ITEM_ADDITIONAL_RATING: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_ITEM_SWATCH_QUICKVIEW_CART_PRICE_CTA: isStaging ? '1.0.0' : '1.0.0',
    CART_VISIBILITY_SETTINGS: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_VENDOR: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_ITEM_INVENTORY_STATUS: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_LIST_BREADCRUMBS: isStaging ? '1.0.0' : '1.0.0',
    COLLECTION_HEADER_PARALLAX: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_SWATCH_BY: isStaging ? '4.1.3' : '1.11.0'
  },
  expanse: {
    PRODUCT_ITEM: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_ITEM_ADDITIONAL_RATING: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_ITEM_SWATCH_QUICKVIEW_CART_PRICE_CTA: isStaging ? '1.0.0' : '1.0.0',
    CART_VISIBILITY_SETTINGS: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_VENDOR: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_ITEM_INVENTORY_STATUS: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_LIST_BREADCRUMBS: isStaging ? '1.0.0' : '1.0.0',
    COLLECTION_HEADER_PARALLAX: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_SWATCH_BY: isStaging ? '4.1.3' : '1.5.0'
  },
  empire: {
    PRODUCT_ITEM: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_ITEM_ADDITIONAL_RATING: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_ITEM_SWATCH_QUICKVIEW_CART_PRICE_CTA: isStaging ? '1.0.0' : '1.0.0',
    CART_VISIBILITY_SETTINGS: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_VENDOR: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_ITEM_INVENTORY_STATUS: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_LIST_BREADCRUMBS: isStaging ? '1.0.0' : '1.0.0',
    COLLECTION_HEADER_PARALLAX: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_SWATCH_BY: isStaging ? '4.1.3' : '5.5.0'
  },
  focal: {
    PRODUCT_ITEM: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_ITEM_ADDITIONAL_RATING: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_ITEM_SWATCH_QUICKVIEW_CART_PRICE_CTA: isStaging ? '1.0.0' : '1.0.0',
    CART_VISIBILITY_SETTINGS: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_VENDOR: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_ITEM_INVENTORY_STATUS: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_LIST_BREADCRUMBS: isStaging ? '1.0.0' : '1.0.0',
    COLLECTION_HEADER_PARALLAX: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_SWATCH_BY: isStaging ? '4.1.3' : '1.4.0'
  },
  broadcast: {
    PRODUCT_ITEM: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_ITEM_ADDITIONAL_RATING: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_ITEM_SWATCH_QUICKVIEW_CART_PRICE_CTA: isStaging ? '1.0.0' : '1.0.0',
    CART_VISIBILITY_SETTINGS: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_VENDOR: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_ITEM_INVENTORY_STATUS: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_LIST_BREADCRUMBS: isStaging ? '1.0.0' : '1.0.0',
    COLLECTION_HEADER_PARALLAX: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_SWATCH_BY: isStaging ? '4.1.3' : '1.3.0'
  },
  motion: {
    PRODUCT_ITEM: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_ITEM_ADDITIONAL_RATING: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_ITEM_SWATCH_QUICKVIEW_CART_PRICE_CTA: isStaging ? '1.0.0' : '1.0.0',
    CART_VISIBILITY_SETTINGS: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_VENDOR: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_ITEM_INVENTORY_STATUS: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_LIST_BREADCRUMBS: isStaging ? '1.0.0' : '1.0.0',
    COLLECTION_HEADER_PARALLAX: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_SWATCH_BY: isStaging ? '3.1.3' : '1.3.0'
  },
  venue: {
    PRODUCT_ITEM: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_ITEM_ADDITIONAL_RATING: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_ITEM_SWATCH_QUICKVIEW_CART_PRICE_CTA: isStaging ? '1.0.0' : '1.0.0',
    CART_VISIBILITY_SETTINGS: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_VENDOR: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_ITEM_INVENTORY_STATUS: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_LIST_BREADCRUMBS: isStaging ? '1.0.0' : '1.0.0',
    COLLECTION_HEADER_PARALLAX: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_SWATCH_BY: isStaging ? '4.1.3' : '1.3.0'
  },
  testament: {
    PRODUCT_ITEM: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_ITEM_ADDITIONAL_RATING: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_ITEM_SWATCH_QUICKVIEW_CART_PRICE_CTA: isStaging ? '1.0.0' : '1.0.0',
    CART_VISIBILITY_SETTINGS: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_VENDOR: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_ITEM_INVENTORY_STATUS: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_LIST_BREADCRUMBS: isStaging ? '1.0.0' : '1.0.0',
    COLLECTION_HEADER_PARALLAX: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_SWATCH_BY: isStaging ? '6.1.3' : '1.2.0'
  },
  flow: {
    PRODUCT_ITEM: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_ITEM_ADDITIONAL_RATING: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_ITEM_SWATCH_QUICKVIEW_CART_PRICE_CTA: isStaging ? '1.0.0' : '1.0.0',
    CART_VISIBILITY_SETTINGS: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_VENDOR: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_ITEM_INVENTORY_STATUS: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_LIST_BREADCRUMBS: isStaging ? '1.0.0' : '1.0.0',
    COLLECTION_HEADER_PARALLAX: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_SWATCH_BY: isStaging ? '4.1.3' : '1.1.0'
  },
  blockshop: {
    PRODUCT_ITEM: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_ITEM_ADDITIONAL_RATING: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_ITEM_SWATCH_QUICKVIEW_CART_PRICE_CTA: isStaging ? '1.0.0' : '1.0.0',
    CART_VISIBILITY_SETTINGS: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_VENDOR: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_ITEM_INVENTORY_STATUS: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_LIST_BREADCRUMBS: isStaging ? '1.0.0' : '1.0.0',
    COLLECTION_HEADER_PARALLAX: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_SWATCH_BY: isStaging ? '2.1.3' : '1.0.0',
  },
  streamline: {
    PRODUCT_ITEM: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_ITEM_ADDITIONAL_RATING: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_ITEM_SWATCH_QUICKVIEW_CART_PRICE_CTA: isStaging ? '1.0.0' : '1.0.0',
    CART_VISIBILITY_SETTINGS: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_VENDOR: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_ITEM_INVENTORY_STATUS: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_LIST_BREADCRUMBS: isStaging ? '1.0.0' : '1.0.0',
    COLLECTION_HEADER_PARALLAX: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_SWATCH_BY: isStaging ? '1.0.4' : '1.0.0',
  },
  horizon: {
    PRODUCT_ITEM: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_ITEM_ADDITIONAL_RATING: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_ITEM_SWATCH_QUICKVIEW_CART_PRICE_CTA: isStaging ? '1.0.0' : '1.0.0',
    CART_VISIBILITY_SETTINGS: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_VENDOR: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_ITEM_INVENTORY_STATUS: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_LIST_BREADCRUMBS: isStaging ? '1.0.0' : '1.0.0',
    COLLECTION_HEADER_PARALLAX: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_SWATCH_BY: isStaging ? '1.0.0' : '1.0.0',
  }
};

export const SUPPORTED_TEMPLATE_VERSION_WITH_FILTER_TREE_AND_ISW_SETTINGS = isStaging
  ? '3.4.0'
  : '2.9.0';

export const MAP_LABEL_TURBO_INSTALLED_FEATURE = {
  [TURBO_FEATURE.COLLECTION_FILTER]: 'AdminHTML.ShopifyIntegration.Guide.menuCollectionPage',
  [TURBO_FEATURE.SEARCH_PAGE_FILTER]: 'AdminHTML.ShopifyIntegration.Guide.menuSearchPage',
  [TURBO_FEATURE.ISW]: 'AdminHTML.ShopifyIntegration.Guide.menuISW'
};
